/* LB Update 291 (Auftrag F10 / F11 / F13 / A07) - lb-fix-dialoge.js
   Ersetzt zur Laufzeit fehlerhafte Teile aus assets/theme.js (282 KB, nicht hochladbar). Laedt NACH theme.js
   (siehe theme-liquid-einfuegungen.md: Script-Tag direkt hinter dem theme.js-Tag, defer). Idempotent: ein
   zweites Laden ist wirkungslos (window.__lbFixDialoge). Rueckbau: window.__lbFixDialoge.uninstall().

   F13  theme.a11y.trapFocus / removeTrapFocus (theme.js: Drawers, Modals, Warenkorb-Formular, Tooltip):
        - Shift+Tab auf dem ersten Element springt zum letzten, Tab auf dem letzten zum ersten (vorher nur Tab am Ende).
        - Fokus ausserhalb (Ankuendigungsleiste, AGB-Link, Browser-Leiste -> Tab): wird in den Container zurueckgeholt.
        - Fokusliste wird bei jedem Tab neu gelesen (Warenkorb baut sich per AJAX um, Positionen verschwinden).
        - leerer Container: Fokus bleibt auf dem Container; verschachtelte Fallen (Drawer + Formular): die aeussere gilt.
        - Wird die fokussierte Position entfernt (letzte Position), geht der Fokus in den Drawer zurueck statt auf BODY.
        - Pro Namensraum genau eine Falle, saubere Listener (vorher stapelten sich keydown-Handler ueber das
          Namensraum-System on/off, das nur den letzten Handler kennt).
        Drawers ohne Klick-Ausloeser (Warenkorb per cart:open / "In den Warenkorb"): Fokus geht beim Schliessen zurueck.
   F11  theme.Modals: Registrierung und Entfernung der window-keyup- und Klick-Handler jetzt am gleichen Ziel mit
        gleicher Funktion (vorher: window.on('keyup.modal') <-> documentElement.off('.modal') = nie entfernt).
   F10  Newsletter-Fenster: Escape schliesst (theme.js nahm es aus), Fokus geht zum konkreten Ausloeser (Blase, Banner-
        Link, vorher fokussiertes Element) zurueck, Dialog-Rolle/Name falls im Markup noch nicht vorhanden. Das globale
        "predictive-search:close-all" (theme.js, jedes Escape) nimmt fremden offenen Fenstern nicht mehr den Fokus.
   A07  Zustaendigkeit fuer das Oeffnen: theme.NewsletterPopup per Ereignis reminder:openNewsletter (Blase, Kopfleiste
        in lb-header-tools.js, Banner-Pfad in lb-optimizer.js) - der Optimizer loest kein zweites modalOpen mehr aus.

   Nur ASCII (Hochladen ueber den Connector). Alle Zeichenketten ohne Umlaute. */
(function () {
  'use strict';
  var W = window, D = document, H = D.documentElement;
  if (W.__lbFixDialoge) { return; }

  function installieren(T) {
    var undo = [];                      /* Rueckbau-Funktionen, in umgekehrter Reihenfolge ausgefuehrt */
    var stats = { fallen: 0, tabUmbruch: 0, zurueckgeholt: 0, escapeUnterdrueckt: 0, rueckfokus: 0, geschlossenEscape: 0 };
    var traps = [];                     /* aktive Fokusfallen {key, container, id, last, hatteFokus, mo} */
    var listening = false;
    var registry = [];                  /* Modal-Instanzen mit eigenen Handlern (fuer uninstall) */
    var letzterKlick = null;

    /* ---------------------------------------------------------------- Hilfen */
    function sichtbar(el) {
      if (!el || !el.isConnected) { return false; }
      if (!el.getClientRects().length) { return false; }
      var cs = W.getComputedStyle(el);
      return cs.visibility !== 'hidden';
    }
    var FOKUS = 'a[href],area[href],button,input,select,textarea,summary,iframe,[tabindex],[contenteditable=""],[contenteditable="true"]';
    function fokussierbar(c) {
      var alle = c.querySelectorAll(FOKUS), aus = [], i, e, ti;
      for (i = 0; i < alle.length; i++) {
        e = alle[i];
        if (e.disabled) { continue; }
        if (e.tagName === 'INPUT' && e.type === 'hidden') { continue; }
        ti = e.getAttribute('tabindex');
        if (ti !== null && parseInt(ti, 10) < 0) { continue; }
        if (e.closest('[inert]')) { continue; }
        if (!sichtbar(e)) { continue; }
        aus.push(e);
      }
      return aus;
    }
    function folgt(a, b) { return !!(a.compareDocumentPosition(b) & 4); }   /* b steht nach a */
    function geht(a, b) { return !!(a.compareDocumentPosition(b) & 2); }    /* b steht vor a */
    function fokus(el) {
      if (!el) { return false; }
      try { el.focus({ preventScroll: true }); } catch (x) { try { el.focus(); } catch (y) { return false; } }
      return D.activeElement === el;
    }
    function nutzbar(el) {
      return !!(el && el.isConnected && !el.hidden && sichtbar(el) && !(el.closest && el.closest('[inert]')));
    }
    /* Container eines offenen Fensters? Modal/Drawer nur "lebendig", solange das Theme sie als offen markiert. */
    function lebendig(c) {
      if (!c || !c.isConnected) { return false; }
      var m = c.closest ? c.closest('.modal,.drawer') : null;
      if (m && m.classList.contains('modal') && !m.classList.contains('modal--is-active')) { return false; }
      if (m && m.classList.contains('drawer') && !m.classList.contains('drawer--is-open')) { return false; }
      return c.getClientRects().length > 0;   /* nur display pruefen: visibility wechselt waehrend der Oeffnen-Animation */
    }
    var AUSNAHME = '#CybotCookiebotDialog,#lb-bis-host,[aria-modal="true"]';
    function ausgenommen(el, c) {          /* ein ANDERES, modales Fenster hat den Fokus uebernommen: nicht eingreifen */
      var m = el && el.closest ? el.closest(AUSNAHME) : null;
      return !!(m && !c.contains(m) && !m.contains(c));
    }

    /* ------------------------------------------------- F13: Fokusfalle */
    function eigner() {
      var l = [], i, t, o, geaendert;
      for (i = traps.length - 1; i >= 0; i--) {
        t = traps[i];
        if (!t.container.isConnected && t.id) {                 /* Container wurde ersetzt: ueber die ID neu finden */
          var n = D.getElementById(t.id);
          if (n) { t.container = n; if (!n.hasAttribute('tabindex')) { n.setAttribute('tabindex', '-1'); } beobachten(t); }
        }
        if (lebendig(t.container)) { l.push(t); }
      }
      if (!l.length) { return null; }
      t = l[0];
      do {                                                     /* aeusserste Falle, die die neueste enthaelt, gilt */
        geaendert = false;
        for (i = 0; i < l.length; i++) {
          o = l[i];
          if (o !== t && o.container !== t.container && o.container.contains(t.container)) { t = o; geaendert = true; }
        }
      } while (geaendert);
      return t;
    }
    /* Merkmale des zuletzt fokussierten Elements (Id, Zeilen-Schluessel data-key, Tag, Klassen), um es nach einem
       AJAX-Umbau (Warenkorb: Menge +/-) am gleichen Platz wiederzufinden. */
    function beschreibe(el, c) {
      if (!el || el === c || el.nodeType !== 1) { return null; }
      var k = el.closest ? el.closest('[data-key]') : null;
      return { id: el.id || '', tag: el.tagName.toLowerCase(), key: (k && c.contains(k)) ? k.getAttribute('data-key') : '',
        cls: typeof el.className === 'string' ? el.className.trim().split(/\s+/).slice(0, 3).join('.') : '' };
    }
    function findeWieder(c, b) {
      var r = null;
      if (!b) { return null; }
      try {
        if (b.id) { r = c.querySelector('#' + (W.CSS && W.CSS.escape ? W.CSS.escape(b.id) : b.id)); }
        if (!r && b.cls) { r = c.querySelector((b.key ? '[data-key="' + b.key.replace(/"/g, '\\"') + '"] ' : '') + b.tag + '.' + b.cls); }
      } catch (x) { r = null; }
      return nutzbar(r) ? r : null;
    }
    function beobachten(t) {
      if (t.mo) { try { t.mo.disconnect(); } catch (x) {} t.mo = null; }
      if (!W.MutationObserver) { return; }
      t.mo = new W.MutationObserver(function () {
        if (t.warte) { return; }
        t.warte = true;
        W.requestAnimationFrame(function () {
          t.warte = false;
          if (traps.indexOf(t) < 0 || !t.hatteFokus) { return; }
          var a = D.activeElement;
          if (a && a !== D.body && a !== H) { return; }          /* Fokus noch irgendwo: nichts tun */
          if (eigner() !== t) { return; }
          var l = fokussierbar(t.container);
          fokus(findeWieder(t.container, t.beschr) || l[0] || t.container);   /* fokussierte Position wurde ersetzt/entfernt */
          stats.zurueckgeholt++;
        });
      });
      t.mo.observe(t.container, { childList: true, subtree: true });
    }
    var pullZeit = 0, pullZaehler = 0;
    function onFokusIn(e) {
      var t = eigner(), el = e.target;
      if (!t || !el || el === D || el === W) { return; }
      var c = t.container;
      if (c === el || c.contains(el)) { t.last = el; t.hatteFokus = true; t.beschr = beschreibe(el, c); return; }
      if (ausgenommen(el, c)) { t.hatteFokus = false; return; }
      var jetzt = Date.now();                                    /* Schleifenschutz gegen fremde Fokus-Raeuber */
      if (jetzt - pullZeit > 300) { pullZaehler = 0; }
      pullZeit = jetzt;
      if (++pullZaehler > 6) { return; }
      var l = fokussierbar(c), ziel;
      if (geht(c, el) && !el.contains(c)) { ziel = l[l.length - 1] || c; }   /* kam von hinten (rueckwaerts) */
      else { ziel = l[0] || c; }
      fokus(ziel);
      stats.zurueckgeholt++;
    }
    function onKey(e) {
      if (e.defaultPrevented || (e.key !== 'Tab' && e.keyCode !== 9)) { return; }
      if (e.altKey || e.ctrlKey || e.metaKey) { return; }
      var t = eigner();
      if (!t) { return; }
      var c = t.container, a = D.activeElement;
      if (a && ausgenommen(a, c)) { return; }
      var l = fokussierbar(c);
      if (!l.length) { e.preventDefault(); fokus(c); stats.tabUmbruch++; return; }
      var first = l[0], last = l[l.length - 1];
      var innen = !!a && a !== D.body && a !== H && c.contains(a);
      var umbruch;
      if (e.shiftKey) { umbruch = !innen || a === c || a === first || folgt(a, first); }
      else { umbruch = !innen || a === last || (a !== c && geht(a, last)); }
      if (umbruch) {
        e.preventDefault();
        fokus(e.shiftKey ? last : first);
        stats.tabUmbruch++;
      }
    }
    function einhaengen() {
      if (listening) { return; }
      listening = true;
      D.addEventListener('keydown', onKey, false);
      D.addEventListener('focusin', onFokusIn, true);
    }
    function aushaengen() {
      if (!listening) { return; }
      listening = false;
      D.removeEventListener('keydown', onKey, false);
      D.removeEventListener('focusin', onFokusIn, true);
    }
    function entfernen(key, container) {
      for (var i = traps.length - 1; i >= 0; i--) {
        if (traps[i].key === key && (!container || traps[i].container === container)) {
          if (traps[i].mo) { try { traps[i].mo.disconnect(); } catch (x) {} }
          traps.splice(i, 1);
        }
      }
      if (!traps.length) { aushaengen(); }
    }
    function trapFocus(options) {
      options = options || {};
      var c = options.container;
      if (!c || !c.setAttribute) { return; }
      var key = options.namespace || 'default';
      entfernen(key, null);                                       /* eine Falle je Namensraum, nie stapeln */
      if (!lebendig(c)) { return; }                               /* z. B. Modal schon wieder zu (100-ms-Verzoegerung) */
      c.setAttribute('tabindex', '-1');
      var t = { key: key, container: c, id: c.id || '', last: null, hatteFokus: false, beschr: null, mo: null, warte: false };
      traps.push(t);
      stats.fallen++;
      beobachten(t);
      einhaengen();
      var ziel = options.elementToFocus || c;
      fokus(ziel);
      if (D.activeElement !== ziel) {                             /* Uebergang laeuft noch: zweimal nachfassen */
        W.requestAnimationFrame(function () {
          if (traps.indexOf(t) > -1 && !c.contains(D.activeElement) && D.activeElement !== c) { fokus(ziel); }
        });
        W.setTimeout(function () {
          if (traps.indexOf(t) > -1 && !c.contains(D.activeElement) && D.activeElement !== c) { fokus(ziel); }
        }, 120);
      }
      if (c === D.activeElement || c.contains(D.activeElement)) { t.hatteFokus = true; t.last = D.activeElement; t.beschr = beschreibe(D.activeElement, c); }
    }
    function removeTrapFocus(options) {
      options = options || {};
      var c = options.container;
      if (c && c.getAttribute && c.getAttribute('tabindex') === '-1') { c.removeAttribute('tabindex'); }
      entfernen(options.namespace || 'default', c || null);
    }
    var origTrap = T.a11y.trapFocus, origRemove = T.a11y.removeTrapFocus;
    T.a11y.trapFocus = trapFocus;
    T.a11y.removeTrapFocus = removeTrapFocus;
    undo.push(function () { T.a11y.trapFocus = origTrap; T.a11y.removeTrapFocus = origRemove; });

    /* --------------------------------- Rueckgabefokus (Newsletter, Drawer) */
    function onKlick(e) {
      var t = e.target, el = t && t.closest ? t.closest('a[href],button,[role="button"],[tabindex]') : null;
      if (el) { letzterKlick = { el: el, t: Date.now() }; }
    }
    D.addEventListener('click', onKlick, true);
    undo.push(function () { D.removeEventListener('click', onKlick, true); });

    function merkeAktives(container) {
      var a = D.activeElement;
      if (a && a !== D.body && a !== H && !(container && container.contains(a))) { return a; }
      return null;
    }
    function rettung() {                                          /* Ausloeser ist weg: ruhiger Anker statt BODY */
      var m = D.getElementById('MainContent');
      if (!m) { return; }
      var hatte = m.getAttribute('tabindex');
      if (hatte === null) { m.setAttribute('tabindex', '-1'); }
      var alt = m.style.outline;
      m.style.outline = 'none';
      fokus(m);
      m.addEventListener('blur', function ab() {
        m.removeEventListener('blur', ab);
        m.style.outline = alt;
        if (hatte === null) { m.removeAttribute('tabindex'); }
      });
    }
    function ersatzFuer(el) {
      var s = el && el.closest ? el.closest('.announcement-slider') : null, a;
      if (!s) { return null; }
      a = s.querySelector('.announcement-slider__slide.is-selected a[href]') || s.querySelector('.announcement-slider__slide:not([inert]) a[href]');
      return nutzbar(a) ? a : null;
    }
    /* LB Update 291 (Auftrag VV-R03): Ist der Ausloeser das Suchfeld der Kopfzeile und wurde per Escape geschlossen, darf die
       Fokusrueckgabe das Suchfenster nicht wieder oeffnen (das Escape hat es im selben Tastendruck schon geschlossen):
       lb-suche.js stellt dafuer window.lbSucheFokusRuhig bereit (gleicher Mechanismus wie die Fokusrueckgabe LB 253 nach Escape). */
    function istSuchfeld(el) { return !!(el && el.matches && el.matches('.lb-header-search input[name="q"], #Search')); }
    function fokusRueck(el, leise) {
      if (leise && istSuchfeld(el) && typeof W.lbSucheFokusRuhig === 'function') { return W.lbSucheFokusRuhig(el); }
      return fokus(el);
    }
    function zurueckZu(ausloeser, pruefeFenster, fallbackBlase, leise) {
      var plan = [0, 80, 200, 350, 500, 800, 1200], i = 0;
      function versuch() {
        var a = D.activeElement;
        if (a && a !== D.body && a !== H) { return; }             /* Nutzerin hat schon woanders hin fokussiert */
        var t = eigner();
        if (t) {                                                  /* ein anderes Fenster ist offen: Fokus dort halten */
          var l = fokussierbar(t.container); fokus(l[0] || t.container); return;
        }
        if (pruefeFenster && pruefeFenster()) { return; }
        var ziel = nutzbar(ausloeser) ? ausloeser : null;
        if (!ziel) { ziel = ersatzFuer(ausloeser); }                /* Banner rotiert weiter: Link der gerade angezeigten Meldung */
        if (!ziel && fallbackBlase) {
          var b = D.querySelector('.lb-nl-bubble__open');
          if (nutzbar(b)) { ziel = b; }
        }
        if (ziel && fokusRueck(ziel, leise)) { stats.rueckfokus++; return; }
        i++;
        if (i < plan.length) { W.setTimeout(versuch, plan[i] - plan[i - 1]); }
        else if (ausloeser || fallbackBlase) { rettung(); }
      }
      versuch();
    }

    /* ------------------------------------------ F11 / F10: theme.Modals */
    var MP = T.Modals.prototype;
    var orig = { bindEvents: MP.bindEvents, unbindEvents: MP.unbindEvents, open: MP.open };
    var wartendeNewsletter = [];
    function newsletterBlockiert(self) {
      var el = D.querySelector('.drawer--is-open,.modal--is-active,.lb-sheet.is-open');
      if (el && el !== self.modal) return true;
      el = D.getElementById('LBSuche');
      if (el && !el.hidden && sichtbar(el)) return true;
      el = D.querySelector('#SiteHeader .search__results');
      if (el && el.children.length && sichtbar(el)) return true;
      el = D.getElementById('CybotCookiebotDialog');
      return sichtbar(el);
    }
    MP.open = function () {
      var self = this;
      if (arguments[1] !== true || !/^NewsletterPopup-/.test(self.id || '') || self.modalIsOpen || !newsletterBlockiert(self)) {
        if (self.__lbNlWarte) { W.clearTimeout(self.__lbNlWarte); self.__lbNlWarte = null; var k = wartendeNewsletter.indexOf(self); if (k > -1) wartendeNewsletter.splice(k, 1); }
        return orig.open.apply(self, arguments);
      }
      if (self.__lbNlWarte) return;
      var args = arguments;
      wartendeNewsletter.push(self);
      function versuch() {
        self.__lbNlWarte = null;
        if (!self.modal || !self.modal.isConnected) { wartendeNewsletter.splice(wartendeNewsletter.indexOf(self), 1); return; }
        if (newsletterBlockiert(self)) { self.__lbNlWarte = W.setTimeout(versuch, 250); return; }
        wartendeNewsletter.splice(wartendeNewsletter.indexOf(self), 1);
        orig.open.apply(self, args);
      }
      self.__lbNlWarte = W.setTimeout(versuch, 250);
    };
    function abbauen(self) {
      var st = self.__lbDlg;
      if (!st) { return; }
      if (st.onKey) { W.removeEventListener('keyup', st.onKey); }
      if (st.onClick && self.modal) { self.modal.removeEventListener('click', st.onClick); }
      if (st.onClosed) { D.removeEventListener('modalClose.' + st.id, st.onClosed); }
      self.__lbDlg = null;
      var k = registry.indexOf(self);
      if (k > -1) { registry.splice(k, 1); }
    }
    function nachSchliessen(self) {
      var el = self.__lbAusloeser; self.__lbAusloeser = null;
      if (!el) { return; }
      var istNl = /^NewsletterPopup-/.test(self.id || '');
      zurueckZu(el, null, istNl, !!self.__lbEsc);
    }
    MP.bindEvents = function () {
      var self = this;
      abbauen(self);                                              /* nie doppelt binden (z. B. open nach open) */
      /* Ausloeser fuer den Rueckgabefokus: bindEvents laeuft am Ende von open() (auch bei den beim Start gebundenen Klick-Ausloesern) */
      var el = null;
      if (letzterKlick && (Date.now() - letzterKlick.t) < 2000 && letzterKlick.el.isConnected) { el = letzterKlick.el; }
      if (!el) { el = merkeAktives(self.modal); }
      self.__lbAusloeser = el;
      var st = self.__lbDlg = { id: self.id };
      st.onKey = function (e) {
        if ((e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27) && self.modalIsOpen) {
          stats.geschlossenEscape++;
          self.__lbEsc = true;                                     /* VV-R03: modalClose (synchron in close()) weiss, dass Escape schliesst */
          try { self.close(); } finally { self.__lbEsc = false; }
        }
      };
      W.addEventListener('keyup', st.onKey);
      if (self.config && self.config.closeOffContentClick && self.modal) {
        st.onClick = function (e) { self.close(e); };
        self.modal.addEventListener('click', st.onClick);
      }
      st.onClosed = function () { nachSchliessen(self); };
      D.addEventListener('modalClose.' + self.id, st.onClosed);
      registry.push(self);
    };
    MP.unbindEvents = function () { abbauen(this); };
    undo.push(function () {
      MP.bindEvents = orig.bindEvents; MP.unbindEvents = orig.unbindEvents; MP.open = orig.open;
      wartendeNewsletter.forEach(function (self) { W.clearTimeout(self.__lbNlWarte); self.__lbNlWarte = null; });
      wartendeNewsletter = [];
      registry.slice().forEach(abbauen);
    });

    /* ------------------- Drawers ohne Klick-Ausloeser: Fokus zurueckgeben */
    var DP = T.Drawers && T.Drawers.prototype;
    if (DP) {
      var dOrig = { open: DP.open, unbindEvents: DP.unbindEvents };
      DP.open = function (evt, rueck) {
        if (!this.isOpen && !(evt && evt.currentTarget) && !rueck) { this.__lbRueck = merkeAktives(this.drawer); }
        return dOrig.open.apply(this, arguments);
      };
      /* LB Update 291 (Auftrag F13, P-f13): theme.js Drawers.close() ruft zuerst activeElement.blur() (Fokus = BODY) und gibt den Fokus an den
         Klick-Ausloeser erst per setTimeout nach 500 ms zurueck. Bei ausgelasteter Seite (Drittanbieter-Skripte) kommt der Zeitgeber spaeter:
         wer unmittelbar nach Escape prueft (oder tippt), findet den Fokus auf BODY (live: F13 3 von 5 bzw. 2 von 3). Jetzt geht der Fokus beim
         Schliessen sofort zurueck (der Zeitgeber des Themes setzt danach denselben Knopf noch einmal, ohne Wirkung). Nicht, wenn schon ein
         anderes Fenster offen ist/oeffnet (modalOpen schliesst die Schublade: dann gehoert der Fokus dem Fenster) oder der Fokus woanders liegt. */
      function sofortZurueck(el) {
        var a = D.activeElement;
        if (a && a !== D.body && a !== H) { return; }
        if (!nutzbar(el) || eigner() || fremdesFensterOffen()) { return; }
        if (fokus(el)) { stats.rueckfokus++; }
      }
      DP.unbindEvents = function () {                              /* wird am Ende von Drawers.close() aufgerufen */
        var r = dOrig.unbindEvents.apply(this, arguments);
        if (!this.isOpen && !this.activeSource && this.__lbRueck) {
          var el = this.__lbRueck; this.__lbRueck = null;
          zurueckZu(el, null, false);
        } else if (!this.isOpen && this.activeSource) {
          sofortZurueck(this.activeSource);
        }
        return r;
      };
      undo.push(function () { DP.open = dOrig.open; DP.unbindEvents = dOrig.unbindEvents; });
    }

    /* ----------- F10: globales close-all (jedes Escape) darf Fremdes nicht blurren */
    function fremdesFensterOffen() {
      return H.classList.contains('modal-open') || H.classList.contains('lb-bis-open') ||
        !!D.querySelector('.drawer--is-open,.modal--is-active,.lb-sheet.is-open');
    }
    function schliesseAlle(e) {
      if (!fremdesFensterOffen()) { return; }
      var a = D.activeElement;
      if (a && a.closest && a.closest('#LBHeaderSearch,.site-header__search-container,#SearchModal,predictive-search,.lb-suche')) { return; }
      e.stopImmediatePropagation();                                /* theme.js: closeSearchDrawer() = blur + js-drawer-open weg */
      stats.escapeUnterdrueckt++;
    }
    D.addEventListener('predictive-search:close-all', schliesseAlle, true);
    undo.push(function () { D.removeEventListener('predictive-search:close-all', schliesseAlle, true); });

    /* --------------------------- F10: Dialog-Rolle und Name (Rueckfall) */
    function dialogAuszeichnen() {
      var m = D.querySelectorAll('[id^="NewsletterPopup-"].modal'), i, el, h;
      for (i = 0; i < m.length; i++) {
        el = m[i];
        if (!el.hasAttribute('role')) { el.setAttribute('role', 'dialog'); }
        if (!el.hasAttribute('aria-modal')) { el.setAttribute('aria-modal', 'true'); }
        if (!el.hasAttribute('aria-labelledby') && !el.hasAttribute('aria-label')) {
          h = el.querySelector('.newsletter-popup__content h1,.newsletter-popup__content h2,.newsletter-popup__content h3');
          if (h && h.textContent.replace(/\s+/g, '')) {
            /* LB Update 291 (Auftrag I-002): Titel-ID ohne Praefix NewsletterPopup-, damit [id^="NewsletterPopup-"] nur das Fenster trifft (gleiches Schema wie sections/newsletter-popup.liquid). */
            if (!h.id) { h.id = el.id.replace(/^NewsletterPopup-/, 'NewsletterTitel-') + '-title'; }
            el.setAttribute('aria-labelledby', h.id);
          } else { el.setAttribute('aria-label', 'Newsletter'); }
        }
      }
    }
    dialogAuszeichnen();
    D.addEventListener('shopify:section:load', dialogAuszeichnen);
    undo.push(function () { D.removeEventListener('shopify:section:load', dialogAuszeichnen); });

    /* ---------------------------------------------------------- Schnittstelle */
    return {
      version: '291.1',
      stats: stats,
      aktiveFallen: function () { return traps.length; },
      eigeneModalHandler: function () { return registry.length; },
      uninstall: function () {
        while (undo.length) { try { undo.pop()(); } catch (x) {} }
        traps.slice().forEach(function (t) { entfernen(t.key, t.container); });
        aushaengen();
        delete W.__lbFixDialoge;
      }
    };
  }

  function start() {
    if (W.__lbFixDialoge) { return; }
    var T = W.theme;
    if (!T || !T.a11y || typeof T.a11y.trapFocus !== 'function' || !T.Modals || !T.Modals.prototype) { return false; }
    W.__lbFixDialoge = installieren(T);
    return true;
  }
  if (start() === false) {
    /* theme.js noch nicht ausgefuehrt (Tag steht vor theme.js): nach DOMContentLoaded einmal erneut versuchen */
    D.addEventListener('DOMContentLoaded', start, { once: true });
  }
})();

(function () {
  'use strict';
  if (window.__lbNavSeitenSperre) return;
  window.__lbNavSeitenSperre = true;
  var root = document.documentElement, nav = document.getElementById('NavDrawer'), body = document.body;
  if (!nav || !body) return;
  var saved = null, props = ['position', 'top', 'left', 'width'];
  function blockedElsewhere() {
    return root.classList.contains('lb-cb-offen') || root.classList.contains('lb-bis-open') || !!document.querySelector('.modal--is-active,.drawer--is-open:not(#NavDrawer),.lb-sheet.is-open');
  }
  function sync() {
    var open = nav.classList.contains('drawer--is-open');
    if (root.classList.contains('lb-nav-seiten-sperre') !== open) root.classList.toggle('lb-nav-seiten-sperre', open);
    if (open && !saved) {
      saved = {x:window.scrollX,y:window.scrollY,styles:{},locked:{}};
      props.forEach(function (p) { saved.styles[p] = {value:body.style.getPropertyValue(p),priority:body.style.getPropertyPriority(p)}; });
      saved.locked = {position:'fixed',top:(-saved.y)+'px',left:(-saved.x)+'px',width:'100%'};
      props.forEach(function (p) { body.style.setProperty(p,saved.locked[p],'important'); });
    }
    if (!open && saved && !blockedElsewhere()) {
      var previous = saved; saved = null;
      props.forEach(function (p) {
        if (body.style.getPropertyValue(p) !== previous.locked[p]) return;
        var s = previous.styles[p];
        if (s.value) body.style.setProperty(p,s.value,s.priority); else body.style.removeProperty(p);
      });
      var behavior = root.style.getPropertyValue('scroll-behavior'), priority = root.style.getPropertyPriority('scroll-behavior');
      root.style.setProperty('scroll-behavior','auto','important');
      window.scrollTo(previous.x,previous.y);
      if (behavior) root.style.setProperty('scroll-behavior',behavior,priority); else root.style.removeProperty('scroll-behavior');
    }
  }
  /* iOS: keine Weitergabe von Wischgesten an den Seitenhintergrund.
     Das Menue selbst bleibt scrollbar; an seinen Grenzen keine Gummiband-Bewegung. */
  var touchY = null;
  function menuScroller(target) {
    return target && target.closest ? target.closest('#NavDrawer .drawer__scrollable') : null;
  }
  function canScroll(el, delta) {
    if (!el || el.scrollHeight <= el.clientHeight + 1) return false;
    return delta > 0 ? el.scrollTop < el.scrollHeight - el.clientHeight - 1 : el.scrollTop > 0;
  }
  document.addEventListener('touchstart', function (e) {
    touchY = e.touches.length === 1 ? e.touches[0].clientY : null;
  }, {passive:true,capture:true});
  document.addEventListener('touchmove', function (e) {
    if (!nav.classList.contains('drawer--is-open') || e.touches.length !== 1 || touchY === null) return;
    var nextY = e.touches[0].clientY, delta = touchY - nextY;
    touchY = nextY;
    if (delta && !canScroll(menuScroller(e.target), delta) && e.cancelable) e.preventDefault();
  }, {passive:false,capture:true});
  document.addEventListener('touchend', function () { touchY = null; }, {passive:true,capture:true});
  document.addEventListener('touchcancel', function () { touchY = null; }, {passive:true,capture:true});
  document.addEventListener('wheel', function (e) {
    if (nav.classList.contains('drawer--is-open') && !canScroll(menuScroller(e.target), e.deltaY) && e.cancelable) e.preventDefault();
  }, {passive:false,capture:true});
  var watch = new MutationObserver(sync);
  watch.observe(nav,{attributes:true,attributeFilter:['class']});
  watch.observe(root,{attributes:true,attributeFilter:['class']});
  window.addEventListener('resize',sync);
  window.addEventListener('pageshow',sync);
  sync();
})();
(function () {
  'use strict';
  if (window.__lbNlDirekt) return;
  window.__lbNlDirekt = true;
  document.addEventListener('reminder:openNewsletter',function () {
    var popup = document.querySelector('[id^="NewsletterPopup-"].modal');
    if (popup) popup.setAttribute('data-lb-nl-direkt','1');
  },true);
  var popup = document.querySelector('[id^="NewsletterPopup-"].modal');
  if (popup) document.addEventListener('modalClose.'+popup.id,function () {
    popup.removeAttribute('data-lb-nl-direkt');
  },true);
})();
